const ondcPolicyData = {
  title: "ONDC Buyer App Engagement & Offer Policy",
  updatedDate: "July 1, 2025",
  introduction: [
    "Mperito, as a Network Participant on the ONDC (Open Network for Digital Commerce), is committed to ensuring fair, consistent, and transparent engagement with all Buyer Side Applications (BSAs).",
    "This policy outlines the criteria under which Mperito may: (a) Refuse to respond to search requests, or (b) Apply differential treatment in terms of offers (e.g., price, features, terms), in accordance with ONDC’s guidelines and principles of network neutrality."
  ],
  sections: [
    {
      title: "Purpose",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "This policy ensures non-discriminatory practices in our engagement with Buyer Side Apps and defines the circumstances under which refusal or differential treatment may occur."
          ]
        }
      ]
    },
    {
      title: "Criteria for Refusal or Differential Treatment",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "Mperito reserves the right to refuse responses or apply differential treatment under the following circumstances:"
          ]
        },
        {
          type: "bullet",
          items: [
            "Non-compliance with ONDC protocols or technical standards.",
            "Evidence of security threats, system abuse, or bot activity (e.g., excessive search or crawl requests).",
            "Fraudulent activity, chargebacks, or violation of Mperito’s platform policies.",
            "Exclusive commercial agreements restricting availability to specific BSAs.",
            "Failure to disclose platform fees, misleading price representation to customers.",
            "Unresolved disputes or repeated delays in payment settlements."
          ]
        }
      ]
    },
    {
      title: "Types of Differential Treatment",
      subtitle: "",
      content: [
        {
          type: "bullet",
          items: [
            "Pricing: Offers, discounts, or prices may vary based on contractual relationships.",
            "Transaction Terms: Differences in shipping, return policy, or support levels.",
            "Feature Access: Certain add-ons or features (e.g., express shipping) may be made selectively available."
          ]
        }
      ]
    },
    {
      title: "Application of Criteria",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "All refusal or differential treatment decisions are applied uniformly, without bias.",
            "We maintain audit logs and apply policies consistently across Buyer Apps.",
            "When refusal or treatment variation is triggered, the BSA will receive a reason code and a designated contact point for redressal."
          ]
        }
      ]
    },
    {
      title: "Review and Updates",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "This policy is reviewed quarterly to ensure it aligns with ONDC rules, legal requirements, and operational changes.",
            "Updates to the policy will be published publicly and versioned appropriately."
          ]
        }
      ]
    },
    {
      title: "Dispute Resolution",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "Buyer Apps may raise queries or disputes by contacting Mperito’s ONDC Support team."
          ]
        },
        {
          type: "bullet",
          items: [
            "Email: support@mindsclik.com"             
          ]
        }
      ]
    },
    {
      title: "Policy Access",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "This policy is publicly available at: https://mperito.com/policy/ondc_seller_app"
          ]
        }
      ]
    },
    {
      title: "Disclaimer",
      subtitle: "",
      content: [
        {
          type: "text",
          items: [
            "This document is subject to change and does not constitute a binding agreement with any Buyer App. All decisions are taken in good faith and in accordance with ONDC guidelines and applicable laws.",
            "",
            "",
            ""
          ]
        }
      ]
    }
  ]
};

export default ondcPolicyData;
